import React, { Dispatch, FC, SetStateAction, useCallback, useContext } from 'react';

import { TableCell, TableRow } from '@material-ui/core';

import { GlobalContext } from '../../../../../store';
import { ScoreType } from '../../../../../store/admin/eventFormats/store';
import { IResult } from '../../../../../store/admin/roundResults/store';
import { IGroupEnrollment } from '../../../../../store/player/games/store';

import { getResultField } from '../../../../admin/EventWizard/Common/ResultsTable/Utils/getResultField';
import { useAssignResultsState } from '../../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { useEventLeaderboardsState } from '../../Context/EventLeaderboards.context';
import { useGetPlayerEvent } from '../../../../../contrib/Hooks/useGetPlayerEvent';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';

interface IProps {
  collapsedRow: number | null;
  flightId: number;
  formatIsStableford: boolean;
  index: number;
  playerResult: IResult;
  roundId?: number;
  setCollapsedRow: Dispatch<SetStateAction<number | null>>;
  setPlayer: Dispatch<SetStateAction<IGroupEnrollment | undefined>>;
  setSelectedGroupId: Dispatch<SetStateAction<number>>;
  singleRoundEvent: boolean;
}

const ScoreTableCollapsedRow: FC<IProps> = props => {
  const {
    collapsedRow,
    flightId,
    formatIsStableford,
    index,
    playerResult,
    roundId,
    setCollapsedRow,
    setPlayer,
    setSelectedGroupId,
    singleRoundEvent
  } = props;

  const {
    actions: {
      scores: { get: getScores }
    },
    roundResults
  } = useContext(GlobalContext);

  const { eventId } = useRouteInfoState();

  const { selectedScoreType, selectedRoundFormat } = useAssignResultsState();
  const { enrollments, selectedRound } = useEventLeaderboardsState();
  const event = useGetPlayerEvent(eventId);

  const onExpand = (groupId: number) => {
    setSelectedGroupId(groupId);
    getScores(groupId);
  };

  const onClick = () => {
    if (roundId && roundId > 0) {
      if (collapsedRow === index) {
        return setCollapsedRow(null);
      }
      setCollapsedRow(index);

      setPlayer(enrollments[playerResult.enrollmentId] as IGroupEnrollment);
      onExpand(playerResult.groupId);
    }
  };

  const displayPosition = () =>
    selectedScoreType === ScoreType.GROSS
      ? formatIsStableford
        ? `${playerResult.strokeGrossStablefordTie ? 'T' : ''}${
            playerResult.strokeGrossStablefordPosition
          }`
        : `${playerResult.strokeGrossTie ? 'T' : ''}${playerResult.strokeGrossPosition}`
      : formatIsStableford
      ? `${playerResult.strokeNetStablefordTie ? 'T' : ''}${
          playerResult.strokeNetStablefordPosition
        }`
      : `${playerResult.strokeNetTie ? 'T' : ''}${playerResult.strokeNetPosition}`;

  const getTotalResult = useCallback(
    (enrollmentId: number) => {
      const result =
        roundResults[-1] && roundResults[-1][flightId]
          ? roundResults[-1][flightId].find(
              roundResult => roundResult.enrollmentId === enrollmentId
            )
          : null;

      const scoreTypeResult = result
        ? selectedScoreType === ScoreType.GROSS
          ? formatIsStableford
            ? result.strokeGrossAuxScore
            : result.strokeGrossStablefordAuxScore
          : formatIsStableford
          ? result.strokeNetAuxScore
          : result.strokeNetStablefordAuxScore
        : 0;

      return formatIsStableford ? scoreTypeResult : scoreTypeResult !== 0 ? scoreTypeResult : 'E';
    },
    [roundResults, event, selectedRoundFormat]
  );

  return (
    <TableRow id={`clickableRowResult-${index}`} key={`tableRowResult-${index}`} onClick={onClick}>
      <TableCell className="index">{displayPosition()}</TableCell>

      <TableCell className="playerName">{`${playerResult.userFirstName} ${
        playerResult.userLastName
      }`}</TableCell>

      {selectedRound && !singleRoundEvent && (
        <TableCell className="result">{getTotalResult(playerResult.enrollmentId)}</TableCell>
      )}

      <TableCell className="result">
        {selectedScoreType
          ? getResultField(
              playerResult,
              formatIsStableford ? 'Score' : 'AuxScore',
              'stroke',
              selectedScoreType,
              false,
              formatIsStableford
            )
          : 0}
      </TableCell>

      {roundId && roundId > 0 && <TableCell className="through">{playerResult.through}</TableCell>}
    </TableRow>
  );
};

export default ScoreTableCollapsedRow;
